import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import Seo from "@/components/Seo";

export default function BlogPost() {
  const { slug } = useParams();
  const { pickL, t } = useI18n();
  const [p, setP] = useState(null);
  useEffect(() => { api.get(`/blog/${slug}`).then((r) => setP(r.data)).catch(() => setP(false)); }, [slug]);
  if (p === null) return <div className="container-x py-24 text-muted-foreground">{t("common.loading")}</div>;
  if (p === false) return <div className="container-x py-24">Not found</div>;
  return (
    <article className="container-x py-14 max-w-3xl">
      <Seo title={pickL(p, "title")} description={pickL(p, "excerpt")} image={p.cover_image} type="article"
        jsonLd={{ "@context": "https://schema.org", "@type": "Article", headline: pickL(p, "title"), description: pickL(p, "excerpt"), image: p.cover_image, author: { "@type": "Organization", name: p.author || "JonuzovicDesign" }, datePublished: p.published_at }} />
      <Link to="/blog" className="inline-flex items-center gap-2 text-sm link-muted mb-6"><ArrowLeft size={16} /> Blog</Link>
      <span className="text-xs uppercase tracking-wide text-primary font-semibold">{p.category}</span>
      <h1 className="font-display text-3xl md:text-4xl font-black tracking-tight mt-2 mb-4">{pickL(p, "title")}</h1>
      <div className="text-sm text-muted-foreground mb-8">{p.author} · {(p.published_at || "").slice(0, 10)}</div>
      <img src={p.cover_image} alt="" className="rounded-2xl border border-border w-full mb-8" />
      <p className="text-lg text-muted-foreground leading-relaxed mb-4 font-medium">{pickL(p, "excerpt")}</p>
      <div className="prose leading-relaxed whitespace-pre-wrap">{pickL(p, "content")}</div>
    </article>
  );
}
